import { getApiConfig } from "helpers/authHelper"
import { get, post, put, del } from "../apiHelper"
import * as url from "../urlHelper"

export const getAllGESOffice = () => {
  return get(url.GES_OFFICE, getApiConfig())
}

export const getGESOffice = id => {
  return get(`${url.GES_OFFICE}/${id}`, getApiConfig())
}

export const createGESOffice = data => {
  return post(url.GES_OFFICE, data, getApiConfig())
}

export const updateGESOffice = (id, data) => {
  return put(`${url.GES_OFFICE}/${id}`, data, getApiConfig())
}

export const deleteGESOffice = id => {
  return del(`${url.GES_OFFICE}/${id}`, getApiConfig())
}
